export class ResetPwd {
  constructor(
    public newPassword?: string,
    public confNewPassword?: string,
  ) {  }
}
